<script>
import CheckBox from '../components/Form/CheckBox.vue';

export default {
  components: { CheckBox },
  props: {
    value: {
      type: String,
      required: true,
    },
    isChecked: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleCheck(newValue) {
      this.$emit("update:isChecked", newValue);
    },
  },
};
</script>

<template>
  <div class="flex flex-row items-start gap-2">
    <CheckBox
      :value="value"
      :is-checked="isChecked"
      @update="handleCheck"
    />
    <span class="text-sm text-ash-900">{{ text }}</span>
  </div>
</template>

<style scoped lang="scss"></style>
